import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../api/axios";

export default function ONUDetail() {
  const { oltId, onuIndex } = useParams();
  const navigate = useNavigate();

  const [onu, setOnu] = useState(null);
  const [loading, setLoading] = useState(true);

  // Función para cargar detalle ONU desde API
  const loadOnu = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/olts/${oltId}/onus/${onuIndex}`);
      setOnu(res.data);
    } catch (err) {
      console.error("Error cargando detalle ONU:", err);
      setOnu(null);
    } finally {
      setLoading(false);
    }
  }, [oltId, onuIndex]);

  useEffect(() => {
    if (!oltId || !onuIndex) return;
    loadOnu();
  }, [oltId, onuIndex, loadOnu]);

  if (loading) {
    return <div className="p-6 text-gray-500">Cargando detalles...</div>;
  }

  if (!onu) {
    return (
      <div className="p-6 text-red-600">
        ONU no encontrada.
        <button
          onClick={() => navigate(-1)}
          className="ml-4 text-blue-600 underline"
        >
          Volver
        </button>
      </div>
    );
  }

  // Resumen Parsed JSON (campos principales)
  const fields = [
    { label: "Estado", value: onu.estado || "Offline" },
    { label: "Cliente", value: onu.cliente || "N/A" },
    { label: "ONU ID", value: onu.onu_id || "N/A" },
    { label: "Potencia RX", value: onu.potencia_rx || "N/A" },
    { label: "Puerto PON", value: onu.puerto_pon || "N/A" },
    { label: "Serial", value: onu.serial || "N/A" },
    { label: "Modelo", value: onu.modelo || "N/A" },
    { label: "Última actualización", value: onu.last_poll || "N/A" },
  ];

  // Convertir history si viene como string JSON
  let history = [];
  if (onu.history) {
    if (typeof onu.history === "string") {
      try {
        history = JSON.parse(onu.history.replace(/'/g, '"'));
      } catch {
        history = [];
      }
    } else if (Array.isArray(onu.history)) {
      history = onu.history;
    }
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 text-blue-600 underline"
      >
        ← Volver
      </button>

      <h1 className="text-2xl font-bold mb-6">
        Detalle técnico ONU: {onuIndex}
      </h1>

      {/* Campos resumidos */}
      <div className="bg-white rounded-xl shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">Campos Parsed JSON</h2>
        {fields.map((f) => (
          <div key={f.label} className="mb-2">
            <strong>{f.label}:</strong> {f.value}
          </div>
        ))}
      </div>

      {/* Parsed JSON completo */}
      <div className="bg-gray-50 rounded-xl shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">Parsed JSON completo</h2>
        <pre className="text-sm overflow-x-auto whitespace-pre-wrap">
          {JSON.stringify(onu, null, 2)}
        </pre>
      </div>

      {/* Raw output si existe */}
      {onu.raw_output && (
        <div className="bg-gray-50 rounded-xl shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Raw Output completo</h2>
          <pre className="text-sm overflow-x-auto whitespace-pre-wrap">
            {onu.raw_output}
          </pre>
        </div>
      )}

      {/* Historial de eventos si existe */}
      {history.length > 0 && (
        <div className="bg-gray-50 rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Historial de eventos</h2>
          <table className="min-w-full text-sm border-t border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-3 py-2 border-b">#</th>
                <th className="px-3 py-2 border-b">Authpass Time</th>
                <th className="px-3 py-2 border-b">Offline Time</th>
                <th className="px-3 py-2 border-b">Cause</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, idx) => (
                <tr key={idx} className="border-t">
                  <td className="px-3 py-2">{idx + 1}</td>
                  <td className="px-3 py-2">{h.auth_time || "-"}</td>
                  <td className="px-3 py-2">{h.offline_time || "-"}</td>
                  <td className="px-3 py-2">{h.cause || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
